import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import EndSidebar from "../EndSidebar";
import { useDispatch } from "react-redux";
import { fetchBalance, fetchSipUserData } from "../../slices/walletSlice";
import { SIPProvider } from "react-sipjs";
import Footer from "../Footer";
import { BASE_DOMAIN, DecryptToken, VOIP_WS_URL } from "../../helper/Constants";
import SIPAdminHandler from "../SIPAdminHandler";

const Layout = (props) => {
  const dispatch = useDispatch();
  const [openNav, setOpenNav] = useState(false);
  const userToken = localStorage.getItem("psx_token");
  const decodedToken = DecryptToken(userToken);
  const OpenNavHandler = () => {
    setOpenNav(!openNav);
  };

  useEffect(() => {
    const body = document.querySelector("body");
    body.classList = openNav ? "toggle-sidebar" : "";
  }, [openNav]);

  useEffect(() => {
    dispatch(fetchBalance());
    dispatch(fetchSipUserData());
  }, [dispatch]);

  return (
    <>
      <SIPProvider options={{
        domain: BASE_DOMAIN,
        webSocketServer: VOIP_WS_URL,
        register: true,
        registerExpires: 300,
        allowLegacyNotifications: true
      }}>

        {decodedToken?.user_id ? (
          <Header openNav={openNav} navHandler={OpenNavHandler} user_id={decodedToken?.user_id} />
        ) : (
          ""
        )}
        <Sidebar openNav={openNav} navHandler={OpenNavHandler} />
        <EndSidebar openNav={openNav} navHandler={OpenNavHandler} />

        <SIPAdminHandler/>

        {/* Fixed main content wrapper with proper margins */}
        {/* <main id="main" className={`main ${openNav ? 'ml-0' : 'ml-64'} transition-all duration-300 pt-16 pb-16`}> */}

    <main className={`${openNav ? 'ml-0' : 'ml-64'}
     min-h-screen p-4 md:p-6 lg:p-8 bg-gray-50 dark:bg-gray-900 transition-colors duration-300
      text-gray-800 dark:text-gray-100 pt-16 pb-16`}>


  
            {props.children}
        </main>

        <Footer />
      </SIPProvider>
    </>
  );
};

export default Layout;
